import CategoryWrapper from './CategoryWrapper';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import { connect } from 'react-redux';
import { compose } from 'redux';
 

export default compose(
    withStyles(styles),
    connect(
        store=>store
    ),
)(CategoryWrapper);

